/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `au` - Australia
 * * `eu` - EU
 * * `us` - US
 */
export enum StorageRegionEnum {
    AU = 'au',
    EU = 'eu',
    US = 'us',
}
